import React from "react";

const TickerGrid: React.FC = () => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-center m-5">Coming Soon</div>
    </div>
  );
};

export default TickerGrid;
